module.exports = __webpack_public_path__ + "static/media/cover.551880a.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articles/2/cover.ogv
// module id = 151s
// module chunks = 0